// For TypeScript compatibility we import and export it this way
import * as _default from './export'
export { _default as default }
